/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeleteUserEligibilityReasonDto { 
    code: DeleteUserEligibilityReasonDto.CodeEnum;
    message: string;
    entityIds: Array<string>;
    amount?: number;
}
export namespace DeleteUserEligibilityReasonDto {
    export type CodeEnum = 'paid_upcoming_participation' | 'wallet_balance_remaining' | 'paid_upcoming_organizer_activity' | 'organizer_earnings_waiting_for_payment' | 'organizer_wallet_balance_remaining' | 'free_upcoming_organizer_activity' | 'wallet_refunded_to_card' | 'wallet_credit_forfeited';
    export const CodeEnum = {
        PaidUpcomingParticipation: 'paid_upcoming_participation' as CodeEnum,
        WalletBalanceRemaining: 'wallet_balance_remaining' as CodeEnum,
        PaidUpcomingOrganizerActivity: 'paid_upcoming_organizer_activity' as CodeEnum,
        OrganizerEarningsWaitingForPayment: 'organizer_earnings_waiting_for_payment' as CodeEnum,
        OrganizerWalletBalanceRemaining: 'organizer_wallet_balance_remaining' as CodeEnum,
        FreeUpcomingOrganizerActivity: 'free_upcoming_organizer_activity' as CodeEnum,
        WalletRefundedToCard: 'wallet_refunded_to_card' as CodeEnum,
        WalletCreditForfeited: 'wallet_credit_forfeited' as CodeEnum
    };
}


